import type { FC } from "react";

import { Form } from "@/ui/components/form/Form";
import { Input } from "@/ui/components/form/Input";
import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { Button } from "@/ui/components/primitives/Button";
import {
  LOGIN_WITH_CODE_DEFAULTS,
  type TLoginWithCodeProps,
} from "./LoginWithCode.config";
import { useLoginWithCode } from "./useLoginWithCode";
import { cn } from "@/ui/lib/utils";

export const LoginWithCode: FC<TLoginWithCodeProps> = (
  {
    code,
    submit = {},
    onSubmit,
    noValidate = LOGIN_WITH_CODE_DEFAULTS.noValidate,
    className,
    children,
    ...props
  },
) => {
  const {
    codeProps,
    submitLabel,
    submitProps,
  } = useLoginWithCode({
    code,
    submit,
  });

  return (
    <div
      data-component="LoginWithCode"
      className="w-full"
    >
      <Form
        {...props}
        noValidate={noValidate}
        onSubmit={onSubmit}
        className={cn(
          "w-full",
          className,
        )}
      >
        <Grid gap="4">
          <Column className="w-full">
            <Input
              {...codeProps}
            />
          </Column>
          { children && (
            <Column className="w-full">
              { children }
            </Column>
          ) }
          <Column className="w-full">
            <Button
              {...submitProps}
              type="submit"
            >
              { submitLabel }
            </Button>
          </Column>
        </Grid>
      </Form>
    </div>
  );
};

LoginWithCode.displayName = "LoginWithCode";
